import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'

import GokuDataGrid from '@/components/GokuDataGrid'
import { generatePathDatacentral, paths } from '@/utils/path'
import { getAffiliatesList } from '@/modules/Affiliate/services'
import { Affiliate } from '@/modules/Affiliate/types'
import { affiliateListColumns } from './columns'
import ActiveFilters from './Filters'

import EyeIcons from '@/icons/EyeIcons'

// Define outside component to prevent re-render
const FILTER_DEFAULT_VALUES = { status: '', tier: '' }

const Active = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('affiliate')

    const actions: IAction<Affiliate>[] = [
        {
            onClick: (row) =>
                navigate(
                    generatePathDatacentral(paths.affiliateDetail, {
                        id: String(row?.affiliate_id),
                    })
                ),
            title: t('view'),
            color: 'primary',
            icon: <EyeIcons />,
        },
    ]

    return (
        <div className="my-2">
            <GokuDataGrid
                apiCall={(payload) =>
                    getAffiliatesList({
                        ...payload,
                        referrer_type: 'non_employee',
                    })
                }
                columns={affiliateListColumns(t)}
                reactQueryKey="affiliate-active"
                actions={actions}
                dataGridProps={{
                    getRowId: (row) => row?.affiliate_id,
                }}
                searchPlaceholder={t('search_affiliate')}
                filterDefaultValues={FILTER_DEFAULT_VALUES}
            >
                {({ control, watch, setValue }) => (
                    <ActiveFilters
                        control={control}
                        watch={watch}
                        setValue={(name, value) => setValue(name as any, value)}
                    />
                )}
            </GokuDataGrid>
        </div>
    )
}

export default Active
